<script lang="ts">
	import type { SubNav } from './types';
	import SubNavLinks from './subNavLinks.svelte';
	import SubNavAnchors from './subNavAnchors.svelte';
	import { device } from '$lib/state/device.svelte';
	interface Props {
		nav: SubNav;
	}

	let { nav }: Props = $props();
</script>

{#if nav.type === 'links'}
	<SubNavLinks entries={nav.entries} />
{:else if nav.mobile || device.data.isDesktop}
	<SubNavAnchors
		entries={nav.entries}
		title={nav.title}
		ctaLabel={nav.ctaLabel}
		ctaTarget={nav.ctaTarget}
	/>
{/if}
